import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { fetchSunrisePatientLinkStart } from "@td/emr";
import { Link } from "../components";
import { I18n } from "@td/shared_utils";
import { isEmpty } from "lodash";
import Loader from '../components/Loader';

const SunriseLink = React.memo(({ sunrisePatientLink, loading, error, memberId, ...props }) => {
  const {
    fetchSunrisePatientLinkStart
  } = props;

  useEffect(() => {
    fetchSunrisePatientLinkStart({ memberId });
  }, [memberId]);

  if (isEmpty(sunrisePatientLink)) return null;
  if (loading) return (<Loader />);
  if (error) return 'Failed to fetch Sunrise ID';

  return (
    <Link href={sunrisePatientLink}>
      Go to Sunrise
    </Link>
  );
});

SunriseLink.displayName = "SunriseLink";

SunriseLink.propTypes = {
  memberId: PropTypes.number.isRequired
};

const mapStateToProps = state => ({
  loading: state.emr.sunrisePatient.fetchSunrisePatientLink.loading,
  error: state.emr.sunrisePatient.fetchSunrisePatientLink.error,
  sunrisePatientLink: state.emr.sunrisePatient.sunrisePatientLink
});

const mapDispatchToProps = dispatch => ({
  fetchSunrisePatientLinkStart: (memberId) => dispatch(fetchSunrisePatientLinkStart(memberId))
});

export default connect(mapStateToProps, mapDispatchToProps)(SunriseLink);
